const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF;

export const StudioFileManagerCommandURL: any = {
    CreateSession: Backofficebff + '/v1/StudioFileManager/create-session',
    CreateFileTransferRequest: Backofficebff + '/v1/FileManager/create-file-transfer-request',
    AppendFileTransferRequestDetails: Backofficebff + '/v1/FileManager/append-file-transfer-request-details',
    UpdateFileTransferRequest: Backofficebff + '/v1/FileManager/update-file-transfer-request',
    ImportLegacyRawTransfer: Backofficebff + '/v1/FileManager/legacy-transfer/import-raw',
    ImportLegacyRetouchTransfer: Backofficebff + '/v1/FileManager/legacy-transfer/import-retouch',
};
